import { render, staticRenderFns } from "./new-seller.modal.vue?vue&type=template&id=60c4a583&scoped=true&"
import script from "./new-seller.modal.vue?vue&type=script&lang=js&"
export * from "./new-seller.modal.vue?vue&type=script&lang=js&"
import style0 from "./new-seller.modal.vue?vue&type=style&index=0&id=60c4a583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4a583",
  null
  
)

export default component.exports